/* @flow */
import URI from 'urijs';

function referrerFromURL(url: string): string {
  if (url === null) return 'Misc';
  let host = URI(url).host();
  if (/[\/.]?folksy\.(?:com|co\.uk)/.test(host)) {
    if (/blog.folksy\.com/.test(host)) {
      return 'Folksy Blog';
    } else if (/talk.folksy\.com/.test(host)) {
      return 'Folksy Forums';
    } else {
      return 'Folksy';
    }
  }
  if (/[.]?\bgoogle\b[\/.]?/.test(host)) {
    return 'Google';
  }
  if (/[.]?\bpinterest\b[\/.]?/.test(host)) {
    return 'Pinterest';
  }
  if (/[.]?\bbing\b[\/.]?/.test(host)) {
    return 'Bing';
  }
  if (/[.]?\bduckduckgo\b[\/.]?/.test(host)) {
    return 'DuckDuckGo';
  }
  if (/[.]?\bfacebook\b[\/.]?/.test(host)) {
    return 'Facebook';
  }
  if (/[.]?\binstagram\b[\/.]?/.test(host)) {
    return 'Instagram';
  }
  if (/[.]?\byahoo\b[\/.]?/.test(host)) {
    return 'Yahoo';
  }
  if (/[.]?\baol\b[\/.]?/.test(host)) {
    return 'AOL';
  }
  if (/[.]?\bt\.co\b[\.]?/.test(host) || /[\.]?\btwitter\b[\/.]?/.test(host)) {
    return 'Twitter';
  }
  if (/^www./.test(host)) {
    return host.slice(4);
  }
  return host;
};

export default referrerFromURL;



// WEBPACK FOOTER //
// ./src/utils/referrer-from-url.js